import { Component } from '@angular/core';
import { DownloadAppButtons } from '../../../components/shared/download-app-buttons';

@Component({
  selector: 'allas-gauge-comienza-a-ganar',
  imports: [DownloadAppButtons],
  template: `
    <section class="grid grid-cols-12 gap-8 w-full mt-6 xl:mt-12">
      <div
        class="col-span-12 xl:col-span-6 relative px-6 xl:px-0 flex justify-center items-start"
      >
        <img
          src="/images/services/afiliaciones/gauge.webp"
          alt="Gauge Comienza a Ganar"
          class="w-full xl:w-2/3 h-auto top-0 left-0"
        />
      </div>

      <div
        class="col-span-12 xl:col-span-6 flex flex-col mt-2 xl:mt-16 xl:m-0 items-center px-6 xl:items-start xl:px-0"
      >
        <span class="text-xl xl:text-3xl font-medium">UNETE Y COMIENZA A</span>
        <span class="text-8xl font-bold fs-condensed">GANAR</span>
        <span class="text-xl xl:text-3xl font-medium">RECOMPENSAS HOY!</span>
        <ol class="list-decimal mt-4">
          <li>1. Afiliate en nuestro APP Allas Repuestos</li>
          <li class="mt-6 xl:mt-0">2. Recibe 1,000 puntos de bienvenida</li>
          <li class="mt-6 xl:mt-0">
            3. Recibe 1 punto por cada Lempira comprado antes de impuesto
          </li>
          <li class="mt-6 xl:mt-0">
            4. Canjea por Premios que podrás ver en nuestra APP ALLAS
          </li>
        </ol>
        <allas-download-app-buttons imgHeightStyleClass="h-14" />
      </div>
    </section>
  `,
})
export class GaugeComienzaAGanar {}
